'use client';
import React from 'react';
import { withReactSuspense } from '../../../hocs/withReactSuspense';
import { useGlobalTrackingScripts } from './index.hook';
import type { Config } from 'u-next/config';

export const GlobalTrackingScripts: React.FC<{
  config: Config;
}> = withReactSuspense(({ config }) => {
  useGlobalTrackingScripts(config);

  return (
    <>
      <script
        defer
        dangerouslySetInnerHTML={{
          __html: `
          !function(t,e){if(void 0===e[t]){e[t]=function(){e[t].clients.push(this),this._init=[Array.prototype.slice.call(arguments)]},e[t].clients=[];for(var r=["addRecord","blockEvents","fetchServerCookie","fetchGlobalID","fetchUserSegments","resetUUID","ready","setSignedMode","setAnonymousMode","set","trackEvent","trackPageview","trackClicks","unblockEvents"],s=0;s<r.length;s++){var c=r[s];e[t].prototype[c]=function(t){return function(){return this["_"+t]=this["_"+t]||[],this["_"+t].push(Array.prototype.slice.call(arguments)),this}}(c)}var n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=("https:"===document.location.protocol?"https:":"http:")+"//cdn.treasuredata.com/sdk/3.1/td.min.js";var o=document.getElementsByTagName("script")[0];o.parentNode.insertBefore(n,o)}}("Treasure",this);
          `,
        }}
      />
      {/* eslint-disable-next-line @next/next/next-script-for-ga */}
      <script
        defer
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-WWD5MFG');
          `,
        }}
      />
      <script
        defer
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'pagelanding',
            });
          `,
        }}
      />
      <script defer src={`${config.SIDE_CAR}/track/initiator`} />
    </>
  );
});
